// eslint-disable-next-line no-unused-vars
import { createMuiTheme } from "@material-ui/core/styles";

export const primary = {
  main: "#2352D0",
  contrastText: "#fff",
};
export const vaildated = {
  main: "#03a94a",
  contrastText: "#fff",
};
export const secondary = {
  main: "#707070",
  contrastText: "#fff",
};

const theme = createMuiTheme({
  palette: {
    primary,
    secondary,
    vaildated,
  },

  typography: {
    fontFamily: "Arial",
    button: {
      textTransform: "none",
    },
  },
});

window.theme = theme;

export default theme;
